export default __webpack_public_path__ + "dim-52a9ee.json";